import React from 'react';
import image from '../images/logo.png';
import { Link } from 'react-router-dom';

function HeaderBar({ title }) {
	return (
		<div
			style={{
				backgroundColor: 'white',
				padding: '10px',
				textAlign: 'center',
				boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
				borderRadius: '5px',
				position: 'fixed',
				top: '0',
				left: '0',
				width: '100%',
				zIndex: '1000',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
			}}
		>
			<p
				style={{
					fontSize: '20px',
					fontWeight: 'bold',
					margin: '0',
					color: '#333',
				}}
			>
				{title}
			</p>
			<Link to={'https://hometech-repairs.in/upload.php'}>
				<img
					src={image}
					alt=""
					style={{
						backgroundColor: '#8cb89f',
						width: '40px',
						marginRight: '20px',
						borderRadius: 10,
					}}
				/>
			</Link>
		</div>
	);
}

export default HeaderBar;
